import React from "react";
import Workspage from "./Workspage";

function Works(props) {
  return (
    <div id="Works">
      <section className="firstheader">
        <hr className="hr" /> MY WORKS
      </section>
      <h1>My Recent Projects</h1>
      <section className="buttons">
       
        <section className="btns">
          <button>All</button>
          <button>Wep App</button>
          <button>Mobile App</button>
          <button>Desktop App</button>
        </section>
      </section>
      <Workspage />
    </div>
  );
}

export default Works;
